import { render } from "./Profile.vue?vue&type=template&id=55b2e4ce&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=55b2e4ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-query-community\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b2e4ce"]])

export default __exports__